import { WPN_POPUP_STATUS } from './get-actions';

export const getInitialState = () => ({
  error: null,
  selectedOptions: {},
  popupStatus: WPN_POPUP_STATUS.NOTHING_IS_SHOWN,
  sdk: undefined,
  isLoading: false,
});
